import { Routes, Route } from 'react-router-dom';
import { SwapProvider } from '@/context/SwapContext';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import WaitlistPage from '@/pages/WaitlistPage';
import './App.css';

function App() {
  return (
    <SwapProvider>
      <div className="min-h-screen bg-background">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
        </Routes>
      </div>
    </SwapProvider>
  );
}

export default App;